module.exports = __webpack_public_path__ + "static/img/GVE-ScreenShot.9dbf9f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/thumbnails/GVE-ScreenShot.jpg
// module id = O6l1
// module chunks = 0